/**
 * @generated SignedSource<<f2c577ac7e395dd64e68058ae10478f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type getDrawingSetAnnotationQuery$variables = {
  id: string;
};
export type getDrawingSetAnnotationQuery$data = {
  readonly drawingSetAnnotation: {
    readonly " $fragmentSpreads": FragmentRefs<"drawingSetAnnotationFragment">;
  } | null | undefined;
};
export type getDrawingSetAnnotationQuery = {
  response: getDrawingSetAnnotationQuery$data;
  variables: getDrawingSetAnnotationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "getDrawingSetAnnotationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetAnnotation",
        "kind": "LinkedField",
        "name": "drawingSetAnnotation",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "drawingSetAnnotationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getDrawingSetAnnotationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetAnnotation",
        "kind": "LinkedField",
        "name": "drawingSetAnnotation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drawingSetId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drawingSheetId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xfdf",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "844fec2da96afd7d41080216a5a88d51",
    "id": null,
    "metadata": {},
    "name": "getDrawingSetAnnotationQuery",
    "operationKind": "query",
    "text": "query getDrawingSetAnnotationQuery(\n  $id: ID!\n) {\n  drawingSetAnnotation(id: $id) {\n    ...drawingSetAnnotationFragment\n    id\n  }\n}\n\nfragment drawingSetAnnotationFragment on DrawingSetAnnotation {\n  id\n  createdAt\n  updatedAt\n  createdById\n  drawingSetId\n  drawingSheetId\n  type\n  xfdf\n}\n"
  }
};
})();

(node as any).hash = "f03ab77914d7161e7e560662e5a65ae7";

export default node;
